import { last } from "@tanstack/router-core";
import { useState, useEffect, useCallback } from "react";
import { useRouter } from "./useRouter.js";
import { useMatch } from "./useMatch.js";
import { useRouterState } from "./useRouterState.js";
const useActiveLocation = (location) => {
  const router = useRouter();
  const routerLocation = useRouterState({ select: (state) => state.location });
  const [activeLocation, setActiveLocation] = useState(
    routerLocation
  );
  const [customActiveLocation, setCustomActiveLocation] = useState(location);
  useEffect(() => {
    setActiveLocation(customActiveLocation ?? routerLocation);
  }, [routerLocation, customActiveLocation]);
  const matchIndex = useMatch({
    strict: false,
    select: (match) => match.index
  });
  const getFromPath = useCallback(
    (from) => {
      const activeLocationMatches = router.matchRoutes(activeLocation, {
        _buildLocation: false
      });
      const activeLocationMatch = last(activeLocationMatches);
      return from ?? (activeLocationMatch == null ? void 0 : activeLocationMatch.fullPath) ?? router.state.matches[matchIndex].fullPath;
    },
    [activeLocation, matchIndex, router]
  );
  return {
    activeLocation,
    getFromPath,
    setActiveLocation: setCustomActiveLocation
  };
};
export {
  useActiveLocation
};
//# sourceMappingURL=useActiveLocation.js.map
